import { mergeAttributes, Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-3';
import IteratorEndWidget from '../editor-widgets/IteratorEndWidget.vue';

export default Node.create({
    name: 'IteratorEndComponent',
    group: 'block',
    content: 'inline*',

    parseHTML() {
        return [
            {
                tag: 'iterator-end-component',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['iterator-end-component', mergeAttributes(HTMLAttributes), 0];
    },

    addNodeView() {
        return VueNodeViewRenderer(IteratorEndWidget);
    },
});
